import React, { useState } from 'react';
import './RiderAssignments.scss';
import { CopyText } from '../../../UiKit';
import Tag from 'sushiweb/Tag';
import { EmptyState, WFHCall } from '../../commons';
import {
  InvalidSearchImg,
  riderScooter,
  viewText,
} from '../../../images/images';
import { valetModel } from '../../../api';
import {
  VALET_EVENTS,
  sendValetApiEvents,
} from '../../../helpers/analytics/valet.analytics';
import toast from 'react-hot-toast';
import { AssignedRiderCallClickEvent } from '../../../analytics/call-logging/events';
import { useSelector } from 'react-redux';

export const riderRoles = {
  BUDDY_RIDER: 'BUDDY_RIDER',
  RIDER: 'RIDER',
};

const ambulanceRoles = [
  'Paramedic',
  'Ambulance Pilot',
  'General Duty Assistant',
];

const AssignmentHistoryItem = ({
  id,
  valetName,
  valetNumber,
  valetId,
  assignedAt,
  assignedBy,
  unassignedAt,
  unassignedBy,
  userId,
  orderId,
  tag,
  cartId = null,
}) => {
  const isNewUI = useSelector((state) => state.ordersState?.isNewUI);

  return (
    <div className='assignmentHistoryItemContainer' data-dd-privacy='mask'>
      <div className='assignmentHistoryItemTopSubContainer'>
        <div className='valetInfoContainer'>
          <div className='riderIconContainer'>
            <img className='icon' src={riderScooter} alt='bike' />
          </div>
          <div className='valetInfo'>
            <div className='valetNameContainer tw-flex tw-gap-1 tw-w-full'>
              <span className=' tw-text-black tw-text-400 tw-font-medium'>
                {valetName}
              </span>
              {valetId ? (
                <CopyText
                  title={valetId}
                  customClass='tw-ml-2 tw-text-black tw-text-200 tw-font-medium'
                />
              ) : null}
              {tag && (
                <div className='valetTag'>
                  <Tag
                    label={tag}
                    textColor='#0A757C'
                    bgColor='#E5F3F3'
                    fontSize='0.8rem'
                  />
                </div>
              )}
            </div>
            {valetNumber && (
              <div className='tw-flex tw-flex-row valetNumberContainer'>
                <ValetDeliveryAssignmentHistory
                  id={id}
                  phone={valetNumber}
                  orderId={orderId}
                  userId={userId}
                  calledTo={'Rider'}
                />
                <WFHCall
                  orderId={orderId}
                  userId={userId}
                  title={valetNumber}
                  calledTo={ambulanceRoles.includes(tag) ? tag : 'Rider'}
                  role={
                    tag === 'Buddy Rider'
                      ? riderRoles.BUDDY_RIDER
                      : ambulanceRoles.includes(tag)
                      ? tag.toUpperCase()
                      : riderRoles.RIDER
                  }
                  valetId={valetId}
                  sendJumboEvent={true}
                  jumboEventFunc={AssignedRiderCallClickEvent}
                  JumboEventProperties={{
                    is_new_ui: isNewUI,
                    valet_name: valetName,
                    valet_number: valetNumber,
                    valet_id: valetId,
                    assigned_by: assignedBy,
                  }}
                  cartId={cartId}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className='assignmentHistoryItemBottomSubContainer'>
        <div className='assignmentHistoryItemBottomSubContainerItem'>
          <p className='label'>Assigned At</p>
          <p className='value'>{assignedAt}</p>
        </div>
        <div className='assignmentHistoryItemBottomSubContainerItem'>
          <p className='label'>Assigned By</p>
          <p className='value'>{assignedBy}</p>
        </div>
        <div className='assignmentHistoryItemBottomSubContainerItem'>
          <p className='label'>Unassigned At</p>
          <p className='value'>{unassignedAt}</p>
        </div>
        <div className='assignmentHistoryItemBottomSubContainerItem'>
          <p className='label'>Unassigned By</p>
          <p className='value'>{unassignedBy}</p>
        </div>
      </div>
    </div>
  );
};

function unmaskNumber(orderID, setNumber, setisMask, id) {
  const queryParams = {
    order_id: orderID,
    offset: id,
  };

  valetModel
    .getDPAssignedUnassignedNumbers(queryParams)
    .then((response) => {
      if (!response || response?.isError === true) {
        return toast.error(
          response.message || 'Something went wrong. Please try again later!',
        );
      }

      sendValetApiEvents(VALET_EVENTS.GET_VALET_NUMBER_SUCCESS, orderID);
      setisMask(false);
      setNumber(response.phone);
    })
    .catch((err) => {
      toast.error(
        err.message || 'Something went wrong. Please try again later!',
      );

      sendValetApiEvents(VALET_EVENTS.GET_VALET_DETAILS_FAILURE, orderID);
    });
}
const ValetDeliveryAssignmentHistory = (props) => {
  const { id, phone, calledTo, orderId, userId } = props;
  const [number, setNumber] = useState(phone);
  const [isMask, setisMask] = useState(true);
  return (
    <div>
      {isMask ? (
        <div className='tw-flex tw-flex-row'>
          <CopyText
            dontShowCopyIcon={true}
            title={number}
            orderId={orderId}
            userId={userId}
            masking={false}
            maskingCount={4}
            calledTo={calledTo}
          />
          <span
            className='pointer icon'
            onClick={() => unmaskNumber(orderId, setNumber, setisMask, id)}
          >
            <img src={viewText} alt='' />
          </span>
        </div>
      ) : (
        <div>
          <CopyText
            title={number}
            orderId={orderId}
            userId={userId}
            masking={false}
            maskingCount={4}
            calledTo={calledTo}
          />
        </div>
      )}
    </div>
  );
};

export const RiderAssignments = ({ data, orderId, userId, cartId }) => {
  if (data?.isError) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading={data?.message || 'No data available.'}
        isPop={true}
      />
    );
  }
  const assignment_history = data?.assignment_history;
  if (!assignment_history || assignment_history.length == 0) {
    return (
      <EmptyState
        img={InvalidSearchImg}
        heading='No data available.'
        isPop={true}
      />
    );
  }

  return (
    <div className='modalContent riderAssignmentsModal'>
      {data?.assignment_history?.length > 0 &&
        data?.assignment_history.map(
          (
            {
              name,
              driver_fe_id,
              phone_no,
              assigned_at,
              assigned_by,
              unassigned_at,
              unassigned_by,
              tag,
            },
            idx,
          ) => (
            <AssignmentHistoryItem
              key={idx}
              id={idx}
              valetName={name}
              valetNumber={phone_no}
              valetId={driver_fe_id}
              assignedAt={assigned_at}
              assignedBy={assigned_by}
              unassignedAt={unassigned_at}
              unassignedBy={unassigned_by}
              orderId={orderId}
              userId={userId}
              tag={tag}
              cartId={cartId}
            />
          ),
        )}
    </div>
  );
};
